<template>
  <div
    class="bl-input-component bg-pure-white flex-shrink-0"
    :class="{
      'bl-input-row': !input.label,
      'bl-input-row-dense': !input.label && input.dense,
      'bl-input-disabled':
        input.disabled || !input.options || !input.options.length,
      'bl-input-active': opened
    }"
    @click="opened = true"
  >
    <!-- // 'bl-input-minified': input.minified, -->
    <!-- :class="
      ${ !input.label ? 'bl-input-row' : ''}
      ${ input.disabled || !input.options || !input.options.length ? 'bl-input-disabled' : ''}
      ${ input.minified ? 'bl-input-minified' : ''}
      ${ opened ? 'bl-input-active' : ''}`
    " -->
    <label
      v-if="!input.minified && input.label"
      class="bl-input-label truncate pr-4"
      :for="id"
    >
      <span class="truncate">{{ input.label }}</span>
      <span
        v-if="input.asterisk"
        class="text-error-400 text-xl absolute -top-2 ml-1"
        >*</span
      >
    </label>
    <label
      v-if="(!input.minified && input.prefix) || input.model"
      class="bl-input-prefix truncate"
      :class="{ 'bl-input-prefix-dense': input.dense }"
      :for="id"
    >
      <div
        v-if="input.model && input.model.prefixColor"
        class="bl-input-prefix-color"
        :style="`background-color: ${input.model.prefixColor}`"
      />
      <span v-if="input.model" class="truncate space-x-2">
        <span>{{ input.combine ? `${input.prefix}` : "" }}</span>
        <span class="font-medium text-grey">{{
          input.model.name || input.model
        }}</span>
      </span>
      <span v-else class="truncate">{{ input.prefix }}</span>
    </label>
    <input
      type="text"
      class="bl-input"
      :class="{ 'bl-input-dense': input.dense }"
      :id="id"
      readonly
      @focusin="opened = true"
      @focusout="opened = false"
    />
    <div
      class="bl-input-border"
      :class="{ 'bl-input-border-dense': input.dense }"
    ></div>
    <BlIcon
      class="bl-input-icon transition-all duration-300"
      :class="{ 'bl-input-icon-dense': input.dense }"
      icon="chevron-down"
      :style="opened ? 'rotate: 180deg' : ''"
    />
    <div v-if="opened" class="bl-input-dropdown" :data-id="id">
      <div
        v-if="input.label || input.prefix || input.placeholder"
        class="bl-input-dropdown-header"
        :data-id="id"
      >
        <BlTextSubtitle2
          :text="input.label || input.prefix || input.placeholder"
          :data-id="id"
        />
      </div>
      <div class="bl-input-dropdown-body" :data-id="id">
        <BlInputSearch
          v-if="input.search"
          class="bl-input-dropdown-search"
          :input="searchInput"
          @changed="inputHandler"
        />
        <div
          v-for="option in options"
          :key="option.value || option"
          class="bl-input-dropdown-option"
          :class="{
            'border-b border-slate-400': option.divider,
            'opacity-25 pointer-events-none': option.disabled
          }"
          :data-id="id"
          @click="valueHandler(option)"
          :title="option.name || option"
        >
          <BlInputRadio
            :checked="(value.value || value) === (option.value || option)"
            :data-id="id"
            :name="id"
            class="flex-shrink-0"
            style="margin: 0"
          />
          <div
            class="bl-input-dropdown-option-name truncate"
            :data-id="id"
            :class="option.prefixColor ? 'pr-6' : ''"
          >
            <div
              v-if="option.backgroundColor"
              :data-id="id"
              class="py-1 px-2.5 rounded truncate"
              :style="{
                backgroundColor: option.backgroundColor,
                color: option.color
              }"
            >
              {{ option.name || option }}
            </div>
            <div v-else :data-id="id">
              {{ option.name || option }}
            </div>
          </div>
          <div
            v-if="option.prefixColor"
            :data-id="id"
            class="bl-input-dropdown-option-color"
            :style="`background-color: ${option.prefixColor}`"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlIcon from "./BlIcon.vue";
import BlInputRadio from "./BlInputRadio.vue";
import BlInputSearch from "./BlInputSearch.vue";
import BlTextSubtitle2 from "./BlTextSubtitle2.vue";

export default {
  props: {
    input: {
      label: {
        type: String,
        required: false
      },
      prefix: {
        type: String,
        required: false
      },
      placeholder: {
        type: String,
        required: false
      },
      disabled: {
        type: Boolean,
        required: false
      },
      model: {
        type: String | Object,
        required: true
      },
      minified: {
        type: Boolean,
        default: false
      },
      combine: {
        type: Boolean,
        default: false
      },
      search: {
        type: Boolean,
        default: false
      },
      /**
       * @Value string[], {
       *   name: string,
       *   value: string
       * }[]
       */
      options: {
        type: Object,
        required: true
      },
      asterisk: {
        type: Boolean,
        default: false
      },
      dense: {
        type: Boolean,
        default: false
      }
    }
  },
  data() {
    return {
      value: "",
      opened: false,
      options: [],
      searchInput: {
        placeholder: "Search",
        model: "",
        id: ""
      }
    };
  },
  computed: {
    id() {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let combination = "";
      for (let i = 0; i < 6; i++) {
        combination += chars[Math.round(Math.random() * 35)];
      }
      return `bl-input-${combination}`;
    },
    search() {
      if (!this.searchInput.model) return "";
      return this.searchInput.model
        .split(" ")
        .join("")
        .toLowerCase();
    }
  },
  components: { BlIcon, BlTextSubtitle2, BlInputRadio, BlInputSearch },
  watch: {
    opened(val) {
      if (val) {
        setTimeout(() => {
          window.addEventListener("click", this.closeHandler);
        }, 10);
      } else {
        this.onChange();
      }
    },
    search(val) {
      if (val) {
        this.options = this.input.options.filter(a =>
          (a.name || a)
            .split(" ")
            .join("")
            .toLowerCase()
            .includes(val)
        );
      } else {
        this.options = this.input.options;
      }
    },
    input: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.options) {
          this.options = val.options;
          this.searchInput.model = "";
        }
        if (val.model) {
          this.value = this.input.model;
        }
      }
    }
  },
  mounted() {
    this.searchInput.id = this.id;
  },
  methods: {
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    valueHandler(val) {
      this.value = val;
    },
    onChange() {
      this.$emit("changed", { input: this.input, value: this.value });
    },
    closeHandler(e) {
      let close = true;
      if (e.target && e.target.dataset && e.target.dataset.id) {
        const id = e.target.dataset.id || "";
        if (id === this.id) close = false;
      }
      if (close) {
        window.removeEventListener("click", this.closeHandler);
        this.opened = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.bl-input-component:not(.bl-input-dropdown-search) {
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  .bl-input-label {
    position: relative;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: calc(5 / 3);
    letter-spacing: 0.5px;
    margin-bottom: 0.25rem;
    padding: 0;
    & ~ .bl-input-border {
      position: relative;
    }
    & + .bl-input-prefix {
      position: absolute;
      top: 1.5rem;
      width: 100%;
      height: 2.5rem;
      padding: 0 2rem 0 1rem;
      &.bl-input-prefix-dense {
        height: 1.875rem;
      }
    }
  }
  .bl-input-prefix {
    pointer-events: none;
    position: relative;
    padding: 0 3rem 0 1rem;
    box-sizing: border-box;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: calc(11 / 7);
    color: var(--font-secondary-color);
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    .bl-input-prefix-color {
      position: relative;
      width: 1.5rem;
      height: 1.5rem;
      aspect-ratio: 1 / 1;
      border-radius: 50%;
    }
  }
  > .bl-input {
    z-index: -1;
    pointer-events: none;
    position: absolute;
    width: 100%;
    height: 2.5rem;
    padding: 0 1rem;
    opacity: 0;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: calc(11 / 7);
    letter-spacing: 0.5px;
    box-sizing: border-box;
    &.bl-input-dense {
      height: 1.875rem;
    }
  }
  > .bl-input-border {
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2.5rem;
    border-radius: 5px;
    box-sizing: border-box;
    border: 1px solid var(--border-color);
    flex-shrink: 0;
    &.bl-input-border-dense {
      height: 1.875rem;
    }
  }
  .bl-input-icon {
    cursor: pointer;
    position: absolute;
    right: 1rem;
    top: 2.25rem;
    width: 1rem;
    height: 1rem;
    &.bl-input-icon-dense {
      top: 1.9375rem;
    }
  }
  .bl-input-dropdown {
    z-index: 99;
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 0.5rem;
    min-width: 15rem;
    width: 100%;
    background: var(--background-depth-one-color);
    border-radius: 5px;
    border: 1px solid var(--border-color);
    box-shadow: 0 0.5rem 1rem rgba(100, 100, 100, 0.05);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .bl-input-dropdown-header {
      position: relative;
      width: 100%;
      padding: 1rem;
      border-bottom: 1px solid var(--border-color);
      box-sizing: border-box;
      display: flex;
      align-items: center;
    }
    .bl-input-dropdown-body {
      position: relative;
      width: 100%;
      max-height: 13.75rem;
      padding: 0 0.5rem;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      .bl-input-dropdown-search {
        position: relative;
        height: 2.5rem;
        margin-top: 0.5rem;
        flex-shrink: 0;
      }
      .bl-input-dropdown-option {
        cursor: pointer;
        position: relative;
        width: 100%;
        height: 3rem;
        padding: 0 0.5rem;
        display: flex;
        flex-shrink: 0;
        gap: 0.75rem;
        align-items: center;
        .bl-input-dropdown-option-name {
          pointer-events: none;
          position: relative;
          font-size: 0.75rem;
          font-weight: 400;
          line-height: calc(5 / 3);
          letter-spacing: 0.5px;
        }
        .bl-input-dropdown-option-tag {
          pointer-events: none;
          position: relative;
          height: 1.5rem;
          padding: 0 0.5rem;
          border-radius: 0.75rem;
          box-sizing: border-box;
          font-size: 0.75rem;
          font-weight: 400;
          line-height: calc(5 / 3);
          letter-spacing: 0.5px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .bl-input-dropdown-option-color {
          position: absolute;
          right: 0;
          top: 0.75rem;
          width: 1rem;
          height: 1rem;
          aspect-ratio: 1 / 1;
          border-radius: 50%;
        }
      }
    }
  }
  &.bl-input-row {
    height: 2.5rem;
    flex-direction: row;
    align-items: center;
    &.bl-input-row-dense {
      height: 1.875rem;
    }
    .bl-input,
    .bl-input-tags {
      width: auto;
      padding: 0 1rem 0 0.5rem;
      display: flex;
      flex: 1;
    }
    .bl-input-icon {
      top: 0.75rem;
      &.bl-input-icon-dense {
        top: 0.4375rem;
      }
    }
  }
  &.bl-input-minified {
    width: auto;
    .bl-input,
    .bl-input-tags {
      width: auto;
      padding: 0 0.5rem;
      display: flex;
      flex: auto;
      overflow: hidden;
    }
    .bl-input-icon {
      position: relative;
      right: 0;
      margin-right: 1rem;
    }
    .bl-input-dropdown {
      width: 15rem;
    }
  }
  &.bl-input-active {
    > .bl-input-border {
      border-color: var(--primary-color);
    }
  }
  &.bl-input-disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BlInputSelect.vue